import { render } from "./CustomIndex.vue?vue&type=template&id=ce13b9f0"
import script from "./CustomIndex.vue?vue&type=script&lang=js"
export * from "./CustomIndex.vue?vue&type=script&lang=js"
script.render = render

export default script